import {ISocketMsg} from "./types";

/**
 * Whether the current account already has this book open on another device/session.
 */
export function isBlockedBySameMember(
  socketMsg: ISocketMsg | undefined,
  memberId: number | string | null | undefined,
  bookId: string | number | null | undefined,
  sessionId: string | undefined
): boolean {
  if (!socketMsg || memberId == null || bookId == null || !sessionId) {
    return false;
  }
  if (socketMsg.conflict === "same_member_other_device") {
    return true;
  }
  const readers =
    socketMsg.activeReaders?.[String(bookId)] ||
    socketMsg.activeReaders?.[Number(bookId) as unknown as string] ||
    [];
  if (!Array.isArray(readers) || readers.length === 0) {
    return false;
  }
  const mid = Number(memberId);
  return readers.some(
    (r) =>
      r.memberId != null &&
      Number(r.memberId) === mid &&
      r.sessionId !== sessionId
  );
}

/**
 * Whether this browser session already has any/this book open (multi-tab).
 */
export function isBlockedBySameSession(
  socketMsg: ISocketMsg | undefined,
  sessionId: string | undefined,
  bookId?: string | number | null
): boolean {
  if (!socketMsg?.activeBooks || !sessionId) {
    return false;
  }
  if (socketMsg.conflict === "same_session") {
    return true;
  }
  if (bookId != null) {
    const sessions =
      socketMsg.activeBooks[String(bookId)] ||
      socketMsg.activeBooks[Number(bookId) as unknown as string];
    if (Array.isArray(sessions) && sessions.includes(sessionId)) {
      return true;
    }
  }
  return Object.values(socketMsg.activeBooks).some(
    (sessions) => Array.isArray(sessions) && sessions.includes(sessionId)
  );
}

export function isBookOpenBlocked(
  socketMsg: ISocketMsg | undefined,
  memberId: number | string | null | undefined,
  sessionId: string | undefined,
  bookId?: string | number | null
): boolean {
  if (socketMsg?.canOpen === false) {
    return true;
  }
  return (
    isBlockedBySameMember(socketMsg, memberId, bookId, sessionId) ||
    isBlockedBySameSession(socketMsg, sessionId, bookId)
  );
}
